import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '../../../../../../components/mui/Core/index'
import Constants from '../../../../../../constants/en.json'
import { setIsUpdateRoleConfirmed } from '../../update-user-role-slice'

function UpdateUserRole({ selectedUser }) {
  const dispatch = useDispatch()
  const selectedRole = useSelector((state) => state.updateUserRole.selectedRole)
  const isRoleUpdateConfirmed = useSelector((state) => state.updateUserRole.isUpdateRoleConfirmed)

  const rootStyle = { minHeight: '160px' }
  const confirmMessageContainerStyle = { marginTop: '20px' }
  const roleContainerStyle = { display: 'flex', justifyContent: 'space-between', marginTop: '12px' }
  const confirmUpdateRoleContainerSyle = { marginTop: '12px', marginBottom: '12px' }
  const confirmUpdateRoleRadioButtonSyle = { padding: 0 }

  const handleRoleUpdateConfirm = () => {
    dispatch(setIsUpdateRoleConfirmed(true))
  }

  return (
    <Box sx={rootStyle}>
      <Box>
        <Typography variant='cardHeader'>
          {Constants.userManagement.updateRole.UPDATE_ROLE}
        </Typography>
        <Box sx={confirmMessageContainerStyle}>
          <Typography>{Constants.userManagement.updateRole.ARE_YOU_SURE_MESSAGE}</Typography>
        </Box>
        <Box sx={roleContainerStyle}>
          <Box>
            <Typography>{Constants.userManagement.updateRole.USER_PREVIOUS_ROLE}:</Typography>
          </Box>
          <Box>
            <Typography>{selectedUser?.role}</Typography>
          </Box>
        </Box>
        <Box sx={roleContainerStyle}>
          <Box>
            <Typography>{Constants.userManagement.updateRole.USER_NEW_ROLE}:</Typography>
          </Box>
          <Box>
            <Typography>{selectedRole}</Typography>
          </Box>
        </Box>
        <Box sx={confirmUpdateRoleContainerSyle}>
          <FormControl>
            <RadioGroup name='confirm-update-role-radio-button-group'>
              <FormControlLabel
                checked={isRoleUpdateConfirmed}
                value
                sx={confirmUpdateRoleRadioButtonSyle}
                control={<Radio />}
                label={Constants.userManagement.updateRole.I_HAVE_CONFIRMED_MESSAGE}
                variant='outlined'
                onChange={handleRoleUpdateConfirm}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}

UpdateUserRole.propTypes = {
  selectedUser: PropTypes.oneOfType([
    PropTypes.shape({
      role: PropTypes.string.isRequired,
    }),
    PropTypes.oneOf([null]),
  ]),
}

export default UpdateUserRole
